import { render, staticRenderFns } from "./HistoryPaperList.vue?vue&type=template&id=f95b4a02&scoped=true&"
import script from "@/scripts/Events/components/HistoryPaperList?vue&type=script&lang=js&"
export * from "@/scripts/Events/components/HistoryPaperList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95b4a02",
  null
  
)

export default component.exports